export const colors = {
  WAITING: "#feb019",
  DOING: "#0076f3",
  COMPLETE: "#00e396",
  EXPIRED: "#ff4560",
};
